export default __webpack_public_path__ + "static/media/goshen45.245c297e.jpg";